import React, { forwardRef } from "react";
import { FastField, useField } from "formik";
import styled, { useTheme } from "styled-components";
import { Body } from "../../Text";
import { Box } from "reflexbox";
import Label from "../Label";
import * as styles from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import Card from "../../Card";
import { useRef } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
const { RadioWrap, Radio, RadioContainer } = styles;

const ToolTip = styled(Box)`
  position: absolute;
  top: 1rem;
  right: 0.5rem;
  cursor: pointer;

  z-index: 20;
  > div {
    top: -0.2rem;
    right: -0.2rem;
    position: absolute;
    width: 10rem;
    z-index: 20;
    display: ${({ show }) => (show ? "flex" : "none")};
  }
`;

const RadioComponent = forwardRef(
  (
    {
      name,
      labelText,
      error,
      required,
      description,
      disabled,
      options,
      onChange,
      id,
      checkedValue,
      autoFocus,
      optionWidth: _optionWidth,
      tooltip,
      value: _value,
    },
    ref
  ) => {
    let optionWidth = _optionWidth;

    if (_optionWidth > 20) optionWidth = 20;
    if (_optionWidth < 100 / 6) optionWidth = 100 / 6;

    const theme = useTheme();
    const [field, meta] = useField(name);

    const _ref = useRef(null);
    const [show, setShow] = useState(false);

    const handleClickOutside = useCallback(
      (e) => {
        if (_ref.current && !_ref.current.contains(e.target) && show) {
          setShow(false);
        }
      },
      [_ref, show]
    );

    useEffect(() => {
      if (show) {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
    }, [handleClickOutside, show]);

    return (
      <RadioContainer>
        {labelText || tooltip ? (
          <Label disabled={disabled} htmlFor={id || name} required={required}>
            {labelText}
            {tooltip && (
              <>
                <ToolTip
                  onMouseLeave={() => setShow(false)}
                  ref={_ref}
                  onClick={() => setShow(!show)}
                  show={show}
                >
                  <FontAwesomeIcon icon={faCircleInfo} />
                  <Card>
                    {tooltip?.startsWith("http") ? (
                      <img src={tooltip} alt={name} />
                    ) : (
                      <Body>{tooltip}</Body>
                    )}
                  </Card>
                </ToolTip>
              </>
            )}
          </Label>
        ) : null}

        {description ? <Body>{description}</Body> : null}

        <Radio flexWrap="wrap" disabled={disabled}>
          <FastField
            name={name}
            id={id || name}
            disabled={disabled}
            innerRef={ref ? ref : undefined}
            error={error}
            type="radio"
            autoFocus={autoFocus}
            required={required}
            value={field.value}
            options={options}
            onChange={onChange}
            {...field}
          />

          {options.map((option, i) => {
            const {
              value,
              label: optionLabel,
              disabled: optionDisabled,
              appearChecked,
            } = option;

            return (
              <RadioWrap
                aF={autoFocus}
                className={`animated-radio ${
                  appearChecked || field.value === value || _value === value
                    ? "checked"
                    : ""
                }`}
                itemNumber={i + 1}
                id={`${value}`}
                numItems={options.length}
                disabled={optionDisabled}
                value={value}
                width={
                  optionWidth
                    ? [
                        "calc(33.3333333% - 0.75rem)",
                        `calc(${optionWidth}% - 0.5rem)`,
                      ]
                    : undefined
                }
                key={value || i}
              >
                {optionLabel}
              </RadioWrap>
            );
          })}
        </Radio>
        {meta.error && meta.touched && (
          <Body my="0.5rem" color={theme.danger}>
            {meta.error}
          </Body>
        )}
      </RadioContainer>
    );
  }
);

export default RadioComponent;
